import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./pages/Login/login.page";
import Maintenance from "./pages/Maintenance/maintenance.page";
import Root from "./components/Root/root.component";
import Home from "./pages/Home/home.page";
import PrivateRoutes from "./utils/PrivateRoutes";
import Materials from "./pages/Materials/materials.page";
import Produces from "./pages/Produces/produces.page";
import ProduceOrder from "./pages/ProduceOrder/produceOrder.page";
import ProduceGroups from "./pages/ProduceGroups/produceGroups.page";
import ProcessingLines from "./pages/Processing/processingLines.page";
import ProcessingReports from "./pages/Processing/processingReports.page";
import ProcessingStats from "./pages/Processing/processingStats.page";
import Machines from "./pages/Machines/machines.page";
import Products from "./pages/Products/products.page";
import Spools from "./pages/Spools/spools.page";
import Cashboxes from "./pages/Cashboxes/cashboxes.page";
import Transactions from "./pages/Transactions/transactions.page";
import Staff from "./pages/Staff/staff.page";
import Profile from "./pages/Profile/profile.page";
import Batches from "./pages/Batches/batches.page";
import Reports from "./pages/Reports/reports.page";
import AssignedWorkers from "./pages/AssignedWorker/assignedWorkers.page";
import Workers from "./pages/Workers/workers.page";
import WorkLogs from "./pages/WorkLogs/workLogs.page";
import Expenses from "./pages/Expenses/expenses.page";
import Clients from "./pages/Clients/clients.page";
import Orders from "./pages/Orders/orders.page";
import Changelogs from "./pages/Changelogs/changelogs.page";
import Investment from "./pages/Investment/investment.page";
import Withdrawal from "./pages/Withdrawals/withdrawals.page";
import Inventory from "./pages/Inventory/inventory.page";
import CashTransfers from "./pages/CashTransfers/cashTransfers.page";
import Salary from "./pages/Salary/salary.page";
import Returns from "./pages/Returns/returns.page";
import SalaryReports from "./pages/SalaryReports/salaryReports.page";
import Residue from "./pages/Residue/residue.page";
import Price from "./pages/Price/price.page";
import PriceChangeRequests from "./pages/PriceChangeRequests/priceChangeRequests.page";
import ProfitExpenses from "./pages/ProfitExpenses/profitExpenses.page";
import ProfitLogs from "./pages/ProfilLogs/profitLogs.page";
import Audit from "./pages/Audit/audit.page";
import AuditItems from "./pages/AuditItems/auditItems.page";
import AuditActions from "./pages/AuditActions/auditActions.page";
import AuditClientItems from "./pages/AuditClientItems/auditClientItems.page";
import TaskOrders from "./pages/TaskOrders/taskOrders.page";
import ProductionQueue from "./pages/ProductionQueue/productionQueue.page";
import TaskOrderReports from "./pages/TaskOrderReports/taskOrderReports.page";
import TaskOrderProductionAllocations from "./pages/TaskOrderProductionAllocations/taskOrderProductionAllocations.page";
import Lists from "./pages/Lists/lists.page";
import Company from "./pages/Company/company.page";
import OrderSettings from "./pages/OrderSettings/orderSettings.page";
import ReportSettings from "./pages/ReportSettings/reportSettings.page";
import CashTransferClients from "./pages/CashTransferClients/cashTransferClients.page";
import ReportReturns from "./pages/ReportReturns/reportReturns.page";
import GlobalSettings from "./pages/GlobalSettings/globalSettings.page";
import Partners from "./pages/Partners/partners.page";
import Profits from "./pages/Profits/profits.page";
import Logs from "./pages/Logs/logs.page";
import Expense from "./pages/Expenses/expense.page";
import AuditActionsStats from "./pages/AuditActionsStats/auditActionsStats.page";
import Commissions from "./pages/Commissions/commissions.page";
import InventoryLogs from "./pages/InventoryLogs/inventoryLogs.page";
import ArchivePage from "./pages/Archive/archive.page";
import ArchiveOrders from "./pages/ArchiveOrders/archiveOrders.page";
import ArchiveTransactions from "./pages/ArchiveTransactions/archiveTransactions.page";
import SalaryArchive from "./pages/SalaryArchive/salaryArchive.page";
import ArchiveReports from "./pages/ArchiveReports/archiveReports.page";
import ArchiveCashTClients from "./pages/ArchiveCashTClients/archiveCashTClients.page";
import ArchiveClients from "./pages/ArchiveClients/archiveClients.page";
import ArchiveCashTransfers from "./pages/ArchiveCashtransfers/archiveCashTransfers.type";
import ArchiveTaskOrder from "./pages/ArchiveTaskOrder/archiveTaskOrder.page";
import ArchiveInventory from "./pages/ArchiveInventory/archiveInventory.page";
import ArchiveInventoryLogs from "./pages/ArchiveInventoryLogs/archiveInventoryLogs.page";
import ArchiveWorker from "./pages/ArchiveWorker/archiveWorker.type";
import ArchiveUsers from "./pages/ArchiveUsers/archiveUsers.page";
import CashTransferPayments from "./pages/CashTransferPayments/cashTransferPayments.page";
import Fillers from "./pages/Fillers/fillers.page";
import TurnoverLogs from "./pages/TurnoverLogs/turnoverLogs.page";
import TurnoverExcelReportsPage from "./pages/TurnoverExcelReports/turnoverExcelReports.page";
import DeliveryExpenses from "./pages/DeliveryExpenses/deliveryExpenses.page";
import Files from "./pages/Files/files.page";
import OrderReturns from "./pages/OrderReturns/orderReturns.page";
import Forks from "./pages/Forks/forks.page";
import MeterReadingRecords from "./pages/MeterReadingRecords/meterReadingRecords.page";
import MeterReadings from "./pages/MeterReadings/meterReadings.page";
import { PartnerLog } from "./pages/PartnerLog/partnerLog.page";
import PositionsPage from "./pages/Positions/positions.page";
import ActionLogPage from "./pages/ActionLog";
import SalaryRequest from "./pages/SalaryRequest/salaryRequest.page";
import CommissionRequest from "./pages/CommissionRequest/commissionRequest.page";
import VatClientsPage from "./pages/VatClients/vatClients.page";
import VatTransactionsPage from "./pages/VatTransactions/vatTransactions.page";
import VatReportsPage from "./pages/VatReports/vatReports.page";
import TasksPage from "./pages/Tasks/tasks.page";
import TurnoverSettingsPage from "./pages/TurnoverSettings/turnoverSettings.page";
import TaskOrderProgress from "./pages/TaskOrderProgress/taskOrderProgress.page";
import SalesUsersPage from "./pages/SalesUsers";
import SidebarSettingsPage from "./pages/SidebarSettings/sidebarSettings.page";
import FeatureVisibilityPage from "./pages/FeatureVisibility/featureVisibility.page";
import ColumnSettingsPage from "./pages/ColumnSettings/columnSettings.page";
import MonthlyOverview from "./pages/MonthlyOverview/monthlyOverview.page";
import CommercialProposalsPage from "./pages/CommercialProposals/commercialProposals.page";
import CommercialProposalFormPage from "./pages/CommercialProposals/commercialProposalForm.page";
import CommercialProposalViewPage from "./pages/CommercialProposals/commercialProposalView.page";

function App() {
  const token = localStorage.getItem("token");

  return (
    <div className="App">
      <Routes>
        <Route path="/maintenance" element={<Maintenance />} />
        {!token && <Route path="login" element={<Login />} />}
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Root />}>
            <Route index element={<Home />} />
            <Route path="materials" element={<Materials />} />
            <Route path="produces" element={<Produces />} />
            <Route path="produce-order" element={<ProduceOrder />} />
            <Route path="produce-groups" element={<ProduceGroups />} />
            <Route path="processing/lines" element={<ProcessingLines />} />
            <Route path="processing/reports" element={<ProcessingReports />} />
            <Route path="processing/stats" element={<ProcessingStats />} />
            <Route path="machines" element={<Machines />} />
            <Route path="products" element={<Products />} />
            <Route path="spools" element={<Spools />} />
            <Route path="cashboxes" element={<Cashboxes />} />
            <Route
              path="cash-transfers/:id/:name"
              element={<CashTransfers />}
            />
            <Route path="salary" element={<Salary />} />
            <Route
              path="profit-credits-expenses"
              element={<ProfitExpenses />}
            />
            <Route path="monthly-overview" element={<MonthlyOverview />} />
            <Route path="audit" element={<Audit />} />
            <Route path="audit-actions" element={<AuditActions />} />
            <Route path="task-orders" element={<TaskOrders />} />
            <Route path="production-queue" element={<ProductionQueue />} />
            <Route path="commercial-proposals" element={<CommercialProposalsPage />} />
            <Route path="commercial-proposals/create" element={<CommercialProposalFormPage />} />
            <Route path="commercial-proposals/:id" element={<CommercialProposalViewPage />} />
            <Route path="commercial-proposals/:id/edit" element={<CommercialProposalFormPage />} />
            <Route path="lists" element={<Lists />} />
            <Route path="settings/company" element={<Company />} />
            <Route path="settings/order" element={<OrderSettings />} />
            <Route path="settings/report" element={<ReportSettings />} />
            <Route path="settings/global" element={<GlobalSettings />} />
            <Route path="settings/turnover" element={<TurnoverSettingsPage />} />
            <Route path="alPechka/returns" element={<ReportReturns />} />
            <Route
              path=":itemId/:type/:name/:currency/transactions"
              element={<Transactions />}
            />
            <Route
              path="/transactions/:itemId/:type"
              element={<Transactions />}
            />
            <Route path="staff" element={<Staff />} />
            <Route path="workers" element={<Workers />} />
            <Route path="profile" element={<Profile />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path=":itemId/:type/:name/batches" element={<Batches />} />
            <Route path=":itemId/:name/:type/reports" element={<Reports />} />
            <Route
              path=":itemId/:type/:name/workers"
              element={<AssignedWorkers />}
            />
            <Route path=":itemId/:name/worklogs" element={<WorkLogs />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="clients/:type" element={<Clients />} />
            <Route
              path="clients/cash-transfers"
              element={<CashTransferClients />}
            />
            <Route
              path=":itemId/:type/:clientType/:name/orders"
              element={<Orders />}
            />
            <Route path=":itemId/:type/:name/orders" element={<Orders />} />
            <Route
              path=":itemId/:type/:name/changelogs"
              element={<Changelogs />}
            />
            <Route path="/:itemId/:name/investments" element={<Investment />} />
            <Route path="/:itemId/:name/withdrawals" element={<Withdrawal />} />
            <Route path="/:itemId/:name/returns" element={<Returns />} />
            <Route
              path="/:itemId/:name/:type/salary-reports"
              element={<SalaryReports />}
            />
            <Route path="/residue/:type/" element={<Residue />} />
            <Route path="/price/:type/" element={<Price />} />
            <Route path="/price-change-requests" element={<PriceChangeRequests />} />
            <Route path="/:itemId/:name/profit-logs" element={<ProfitLogs />} />
            <Route path="/audit/:id/items" element={<AuditItems />} />
            <Route
              path="/audit/:id/client-items"
              element={<AuditClientItems />}
            />
            <Route
              path="/task-order/:id/reports"
              element={<TaskOrderReports />}
            />
            <Route
              path="/task-order/:id/production-allocations"
              element={<TaskOrderProductionAllocations />}
            />
            <Route
              path="/task-order/:id/progress"
              element={<TaskOrderProgress />}
            />
            <Route path="partners" element={<Partners />} />
            <Route path="/:startDate/:endDate/profits" element={<Profits />} />
            <Route path="/:startDate/:endDate/logs" element={<Logs />} />
            <Route path="/:startDate/:endDate/expenses" element={<Expense />} />
            <Route
              path="/:startDate/:endDate/audit-actions"
              element={<AuditActionsStats />}
            />
            <Route
              path="/:startDate/:endDate/commisions"
              element={<Commissions />}
            />
            <Route
              path="/inventory/:id/:name/logs"
              element={<InventoryLogs />}
            />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/archive/orders" element={<ArchiveOrders />} />
            <Route
              path="/archive/transactions"
              element={<ArchiveTransactions />}
            />
            <Route path="/archive/salary-reports" element={<SalaryArchive />} />
            <Route path="/archive/reports" element={<ArchiveReports />} />
            <Route
              path="/archive/cash-transfer-clients"
              element={<ArchiveCashTClients />}
            />
            <Route
              path="/archive/clients"
              element={<ArchiveClients />}
            />
            <Route
              path="/archive/cash-transfers"
              element={<ArchiveCashTransfers />}
            />{" "}
            <Route path="/archive/task-order" element={<ArchiveTaskOrder />} />
            <Route path="/archive/inventory" element={<ArchiveInventory />} />
            <Route
              path="/archive/inventory-logs"
              element={<ArchiveInventoryLogs />}
            />
            <Route path="/archive/workers" element={<ArchiveWorker />} />
            <Route path="/archive/users" element={<ArchiveUsers />} />
            <Route
              path="/payments/:name/:id/"
              element={<CashTransferPayments />}
            />
            <Route path="/fillers" element={<Fillers />} />
            <Route path="/turnover/logs" element={<TurnoverLogs />} />
            <Route path="/turnover/excel-reports" element={<TurnoverExcelReportsPage />} />
            <Route path="/delivery-expenses" element={<DeliveryExpenses />} />
            <Route path="/files" element={<Files />} />
            <Route
              path="/order/sale-returns/:id/:name/:receipt"
              element={<OrderReturns />}
            />
            <Route path="/forks" element={<Forks />} />
            <Route path="/forks/:id/:name" element={<Forks />} />
            <Route path="/meter-readings" element={<MeterReadings />} />
            <Route
              path="/meter-readings/records/:id/:name"
              element={<MeterReadingRecords />}
            />
            <Route path="/partner-logs/:id/:name" element={<PartnerLog />} />
            <Route path="/positions" element={<PositionsPage />} />
            <Route path="action-log" element={<ActionLogPage />} />
            <Route path="salary-request" element={<SalaryRequest />} />
            <Route path="commission-request" element={<CommissionRequest />} />
            <Route path="/vat/clients" element={<VatClientsPage />} />
            <Route path="/vat/transactions" element={<VatTransactionsPage />} />
            <Route path="/vat/reports" element={<VatReportsPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/crm/sales-users" element={<SalesUsersPage />} />
            <Route path="/sidebar-settings" element={<SidebarSettingsPage />} />
            <Route path="/settings/features" element={<FeatureVisibilityPage />} />
            <Route path="/settings/columns" element={<ColumnSettingsPage />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
